enum ConfiguracaoWhatsAppSituacao {
    Desconectado = 1,
    ProntoParaUso = 2,
}

export default ConfiguracaoWhatsAppSituacao;
